module.exports = __webpack_public_path__ + "assets/img/map-location.b10b9c05.svg";